
<template>
    <div>
        <header-portrate /> 
        <exports-print ref="exportbar" />
    <div>
       <bread-crumbs :items="items"></bread-crumbs> 
        <tabs-comp :tabs="tabs" />

        <v-row style="margin-top:30px;margin-inline-start: 10px;margin-inline-end: 40px;">
            <v-col cols="12" md="12" sm="12" :style="`direction:`+lang.dir+`;text-align:`+lang.algin">
                <form autocomplete="off">
                    <div class="searchTop">
                        <div class="searchBar">
                            <div>
                                <div class="mobileFont">{{lang.chose_from_list}} {{lang.start_date}}</div>
                                <b-input-group>
                                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="sd.day" :options="daysList"/>
                                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="sd.month" :options="monthsList" />
                                    <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="sd.year" :options="yearsList" />
                                </b-input-group>
                            </div>
                            <div>
                                <div class="mobileFont">{{lang.chose_from_list}} {{lang.end_date}}</div>
                                <b-input-group>
                                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;" v-model="ed.day" :options="daysList"/>
                                    <b-form-select class="inborder text-center" style="width:33%;background:#efefef;border-right:none !important;" v-model="ed.month" :options="monthsList" />
                                    <b-form-select class="inborder text-center" style="width:34%;background:#efefef;" v-model="ed.year" :options="yearsList" />
                                </b-input-group>
                            </div>
                            <div>
                                <div class="mobileFont">{{lang.end_date}}</div>
                                <b-input-group>
                                    <b-form-input class="inborder" v-model="mobile" style="background:#efefef;" />
                                </b-input-group>
                            </div>
                            <div>
                                <div class="mobileFont">{{lang.invoiceno}}</div>
                                <b-input-group>
                                    <b-form-input class="inborder" v-model="invoiceno" style="background:#efefef;" />
                                </b-input-group>
                            </div>
                            <div>
                                <div class="mobileFont">{{lang.vendor_name}}</div>
                                <b-input-group>
                                    <b-form-input class="inborder" v-model="vendor_name" style="background:#efefef;" />
                                </b-input-group>
                            </div>
                            <div>
                                <div class="mobileFont">{{lang.chose_from_list}} {{lang.status}}</div>
                                <b-input-group>
                                    <b-form-select
                                    class="selborder"
                                    v-model="status"
                                    :options="doneOptions"
                                    ></b-form-select>
                                    <b-input-group-append :style="`margin-${lang.algin}:-20px;margin-top:5px;`">
                                        <i class="fas fa-arrow-down"></i>
                                    </b-input-group-append>
                                </b-input-group>
                            </div>
                            <div>
                                <div>&nbsp;</div>
                                <b-button variant="light" style="padding-top:2px !important; padding-bottom:2px !important;background:blue;color:#fff;width:75px;" class="btnMobile"  @click="getInvoice()">{{lang.search}}</b-button>
                            </div>
                        </div>
                        <div style="margin-inline-end:0px;">
                            <b-button
                                v-b-toggle.add_addporch
                                class="btn-sm btn addMobile"
                                @click="_AddPurch()"
                                style="margin-top:9px;background:transparent;border:none !important;margin-left:-7px !important;"
                                id="multiply-button" 
                            >
                                <div :class="`multiply-button-content-`+lang.lalgin" style="width:150px;border:none !important">{{lang.add_purcahse}}</div>
                            </b-button>
                        </div>
                    </div>
                </form>
            </v-col>
            
            <v-col cols="12" md="12" sm="12" :style="`direction:`+lang.dir+`;text-align:`+lang.align">
                <v-data-table
                    :headers="headers"
                    :items="purchrows"
                    :search="search"
                    :items-per-page="15"
                    class="elevation-1"
                    hide-default-footer
                    hide-default-header
                    fixed-header
                >
                <template slot="body.prepend">  
                    <tr>
                        <td v-for="(iHead, indHead) in headers" :key="indHead" 
                            :class="iHead.class + ` text-center `" style="border:1px solid #000 !important;"
                        >
                            {{ iHead.text }}
                        </td>
                    </tr>
                    <tr>  
                        <td style="font-size:.1rem !important;background:#fff !important;border-inline :none !important;border-top:1px solid #000 !important;" :colspan="`8`">&#32;</td>
                        <td style="font-size:.1rem !important;background:#fff !important;border-inline :none !important;border-bottom :2px solid #bbb !important;border-top:1px solid #000 !important;">&#32;</td>
                    </tr>
                </template>
                <template v-slot:item="row">
                <tr>
                    <td class="text-center" style="width:70px">{{ row.item.id }}</td>
                    <td class="text-center" style="width:70px" v-if="row.item.cashajl == 1">فاتورة نقدية</td>
                    <td class="text-center" style="width:70px" v-if="row.item.cashajl == 2">فاتورة آجلة</td>
                    <td class="text-center" style="width:70px">{{ row.item.bill_number }}</td>
                    <td class="text-center" nowrap>{{ row.item.vendor }}</td>
                    <td style="width:100px;" class="text-center">{{ row.item.bill_date }}</td>
                    <td style="width:100px;" class="text-center">{{ row.item.total }}</td>
                    <td style="width:100px;" class="text-center">{{ row.item.vat }}</td>
                    <td style="width:100px;" class="text-center">{{ row.item.ftotal }}</td>
                    <td class="text-center" style="width:80px;background:red !important;color:#FFF !important;border-bottom:2px solid #FFF !important;">
                    <div @click="delItem(row.item)">{{lang.delete}}</div>
                    </td>
                    <td class="text-center" style="width:80px;background:blue !important;color:#FFF !important;border-bottom:2px solid #FFF !important;">
                    <div @click="ViewItem(row.item)" v-b-toggle.viewPurch>
                        {{lang.view}}
                    </div>
                    </td>
                </tr>
                </template>
                <template slot="body.append">
                        <tr>  
                            <td style="font-size:.1rem !important;background:#fff !important;border-inline :none !important;border-top:1px solid #bbb !important;border-bottom :1px solid #000 !important;" :colspan="`8`">&#32;</td>
                            <td style="font-size:.1rem !important;background:#fff !important;border-inline :none !important;border-bottom :1px solid #000 !important;border-top:1px solid #000 !important;">&#32;</td>
                        </tr>
                        <tr>
                            <th class="backEmpty"> </th>
                            <th class="backEmpty"> </th>
                            <th class="backEmpty"> </th>
                            <th class="backEmpty"> </th>
                            <th class="backBlack" style="text-align:center;font-size:1.2em;background:#ccc;font-weight:bold">{{lang.totals}} </th>
                            <th class="backBlack" style="text-align:center;font-size:1.2em;background:#ccc;font-weight:bold">{{totals.total}}</th>
                            <th class="backBlack" style="text-align:center;font-size:1.2em;background:#ccc;font-weight:bold">{{totals.vat}}</th>
                            <th class="backBlack" style="text-align:center;font-size:1.2em;background:#ccc;font-weight:bold">{{totals.ftotal}}</th>
                            <th class="backEmpty"></th>
                            <th class="backEmpty"></th>
                        </tr>
                </template>
                </v-data-table>
                <v-container style="direction:rtl">
                    <div class="text-center pt-2" style="direction:rtl">
                    <v-pagination
                        v-model="page"
                        value="10"
                        :length="pageCount"
                        style="direction:rtl"
                        color="#000"
                        @input="getNext(page)"
                    ></v-pagination>
                    </div>
                </v-container>
            </v-col>
        </v-row> 
        <Purchase ref="addPurch" />
    </div>
        <Footer />
        <div class="loadingPage" v-if="$store.state.showLoading">
        <v-progress-circular
            :width="3"
            color="green"
            indeterminate
        ></v-progress-circular>
        </div>
        <ViewPurchase ref="viewMenow" />
    </div>
</template>

<script>
import axios from 'axios';
import Purchase from '../components/Purchase.vue'
import breadCrumbs from '@/components/breadCrumbs.vue';
import TabsComp from '@/components/tabsComp.vue';
import HeaderPortrate from '@/components/Header-Portrate.vue';
import Footer from '@/components/Footer.vue';
import ViewPurchase from '@/components/ViewPurchase.vue';
import ExportsPrint from '@/components/exports-print.vue';
export default{
    components:{
        Purchase, breadCrumbs,TabsComp,
        HeaderPortrate,Footer,
        ViewPurchase, ExportsPrint
    },
    data() {
        return {
            status: 0,
            totals: {
                vat: 0,
                total: 0,
                ftotal:0
            },
            allres: 0,
            cpage:0,
            id:0,
            active_tab:2,
            search: '',
            purchrows:[],
            // sdate: '',
            // edate: '',
            vendor_name: '',
            mobile: '',
            invoiceno: '',
            page: 1,
            pageCount:0,
            sd: {
                day: 1,
                month: (new Date()).getMonth(),
                year: (new Date()).getFullYear(),
            },
            ed: {
                day: (new Date()).getDate() + 1,
                month: (new Date()).getMonth() + 1,
                year: (new Date()).getFullYear(),
            }
        }
    },
    computed: {
        shoTotals: function (){
            let t = false;
            
            if(this.pageCount == this.page){
                t = true;
            }
            // console.log([this.pageCount,this.page,this.cpage,t]);
            t = true;
            return t;
        },
        cpages: function(){
            // alert(parseFloat(this.page) * 15);
            // alert(this.pageCount);
            if(parseFloat(this.page) * 15 >= this.allres){
            return true
            }
            return false;
        },
       lang: function(){
            if(this.$cookies.get(this.$store.state.LangCooki) != null){
                if(this.$cookies.get(this.$store.state.LangCooki)  == 'en'){
                return this.$store.state.lang.en;
                }else{
                return this.$store.state.lang.ar;
                }
            }
            else if(this.$store.state.deflang == 'en'){
                return this.$store.state.lang.en;
            }else{
                return this.$store.state.lang.ar;
            }
        },
        sdate: function() {
            return (new Date(this.sd.year,this.sd.month-1, this.sd.day+1)).toISOString().substring(0,10);
        },
        edate: function() {
            return (new Date(this.ed.year,this.ed.month-1, this.ed.day+1)).toISOString().substring(0,10);
        },
        yearsList: function(){
            const start_year = this.$store.state.licenseType.startYear;
            let t = [{text: this.lang.year, value: -1}];
            for(let i=0;i<100;i++){
            if(parseInt(start_year) + i <= (new Date()).getFullYear()){
                t.push({text: start_year + i, value: start_year+i})
            }
            
            }
            return t
        },
        daysList: function(){
            return [
            {text: this.lang.day, value: -1},
            {text: 1, value: 1},
            {text: 2, value: 2},
            {text: 3, value: 3},
            {text: 4, value: 4},
            {text: 5, value: 5},
            {text: 6, value: 6},
            {text: 7, value: 7},
            {text: 8, value: 8},
            {text: 9, value: 9},
            {text: 10, value: 10},
            {text: 11, value: 11},
            {text: 12, value: 12},
            {text: 13, value: 13},
            {text: 14, value: 14},
            {text: 15, value: 15},
            {text: 16, value: 16},
            {text: 17, value: 17},
            {text: 18, value: 18},
            {text: 19, value: 19},
            {text: 20, value: 20},
            {text: 21, value: 21},
            {text: 22, value: 22},
            {text: 23, value: 23},
            {text: 24, value: 24},
            {text: 25, value: 25},
            {text: 26, value: 26},
            {text: 27, value: 27},
            {text: 28, value: 28},
            {text: 29, value: 29},
            {text: 30, value: 30},
            {text: 31, value: 31},
            ]
        },
        monthsList: function(){
            return [
            {text: this.lang.chose_month, value: -1},
            {text: 1, value: 1},
            {text: 2, value: 2},
            {text: 3, value: 3},
            {text: 4, value: 4},
            {text: 5, value: 5},
            {text: 6, value: 6},
            {text: 7, value: 7},
            {text: 8, value: 8},
            {text: 9, value: 9},
            {text: 10, value: 10},
            {text: 11, value: 11},
            {text: 12, value: 12},
            ]
        },
        headers: function() {
            return [
                
                {
                    text: "#",
                    align: 'center',
                    sortable: true,
                    value: 'bill_number',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.bill_type,
                    align: 'center',
                    sortable: true,
                    value: 'bill_number',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.invoiceno,
                    align: 'center',
                    sortable: true,
                    value: 'bill_number',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.vendor,
                    align: 'center',
                    sortable: false,
                    value: 'vendor',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.inv_date,
                    align: 'center',
                    sortable: false,
                    value: 'bill_date',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.total,
                    align: 'center',
                    sortable: false,
                    value: 'total',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.vat,
                    align: 'center',
                    sortable: false,
                    value: 'vat',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.ftotal,
                    align: 'center',
                    sortable: false,
                    value: 'ftotal',
                    class:"backBlack",
                    printRemove: 0
                },
                {
                    text: this.lang.delete,
                    align: 'center',
                    sortable: false,
                    value: 'none',
                    class:"backRed",
                    printRemove: 0
                },
                {
                    text: this.lang.action,
                    align: 'center',
                    sortable: false,
                    class:"backBlue",
                    value: 'none',
                    printRemove: 1
                }
            ]
        },
        tabs: function() {
            const menu = this.$store.getters['state'].menu;
            const license = this.$store.getters['state'].licenseType.activemenu;
            const alicense = this.$store.getters['state'].licenseType
            let currentMenu = menu[license];
            if(!license){
              return false;
            }
            let cMenu = {main: {},sub:[]};
            Object.values(currentMenu).forEach(value =>{
            const cM = localStorage.getItem('currentMenu');
            if(value.main.index == cM){
                cMenu = value.sub;
            }else if(cM == null && value.main.index == 1){
                cMenu = value.sub;
            }
            });
        
            let t = []
            Object.values(cMenu).forEach(value =>{
            
                if(this.$route.path == value.href){
                    value.class = "mytab";
                }else{
                    value.class = "mytab4";
                }
                if(this.lang.langname == 'ar'){
                    value.name = value.arname
                }else{
                    value.name = value.enname
                }
                for(let i =0; i< value.groupid.length;i++){
                    if(value.groupid[i] == this.$store.getters['state'].group_id){
                    if(alicense[value.perms[0]] || value.perms[0] == 'any')
                        t.push(value)
                    }
                }
            
            })
        
            return t;         
        },
        items: function() {
            return {
                    text: this.lang.purchase,
                    disabled: true,
                    to: '/finance/purchase',
                }
        },
        ptotals: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].total) + parseFloat(x);
            }
            return this.$RoundNum(x);
        },
        pvat: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].vat) + parseFloat(x);
            }
            return this.$RoundNum(x);
        },
        pftotals: function(){
            let x = 0;
            for(let i = 0;i < this.purchrows.length;i++){
                x = parseFloat(this.purchrows[i].ftotal) + parseFloat(x);
            }
            return this.$RoundNum(x);
        },
        doneOptions: function(){
            let t = [
                {text: 'عرض الكل', value: 0},
                {text: 'مشتريات مفوترة', value: 1}, // Used in car job order and invoiced
                {text: 'مشتريات غير مفوترة', value: 2}, // used in car job order and not invoiced
                {text: 'مشتريات غير مستخدمة', value: 3} // never used in car job order
            ];

            return t;
        },
    },
    methods: {
        collectSearch(){
            return {
            module: 'purchase',
                elements: {
                    sdate: this.sdate,
                    edate: this.edate,
                    mobile: this.mobile,
                    vendor_name: this.vendor_name,
                    invoiceno: this.invoiceno
                }
            }
        },
        getStartDate(){
            let d = (new Date()).getDate();
            let m = (new Date()).getMonth() + 1;
            let y = (new Date()).getFullYear();
            if(parseInt(d) < 30){
            d = parseInt(30) - parseInt(d);
            if(parseInt(m) == 1){
                m = 12
                y = parseInt(y) - 1
            }
            else if(parseInt(m) > 1){
                m = parseInt(m) - 1;
            }
            }else if(parseInt(d) == 30){
            d = 1;
            }else{
            d = parseInt(d) - parseInt(30);
            }
            this.sd.day = 1;
            this.sd.month = 1;
            this.sd.year = y;
        },
        
        preparedata(){ 
            let exdata = {
                list: "purchaseList",
                title: this.lang.purchase,
                data: [],
            }
            for(let i=0;i<this.purchrows.length;i++){
                exdata.data.push(this.purchrows[i]);
            }
            // // console.log(exdata);
            this.$refs.exportbar.exportdata = exdata;
            this.$refs.exportbar.sdate = this.sdate;
            this.$refs.exportbar.edate = this.sdate;
  
        },
        _AddPurch(){
            
            this.$refs.addPurch.vendorid = '';
            this.$refs.addPurch.discount = '';
            this.$refs.addPurch.bill_number ='';
            this.$refs.addPurch.modal = false;
            this.$refs.addPurch.vendor = '';
            this.$refs.addPurch.mobile = '';
            this.$refs.addPurch.bill_date = '';
            this.$refs.addPurch.vat_number = '';
            this.$refs.addPurch.vendor_address = '';
            this.$refs.addPurch.paytype = 1;
            this.$refs.addPurch.vattype = 2;
            this.$refs.addPurch.full_total =0;
            this.$refs.addPurch.full_vat =0;
            this.$refs.addPurch.full_ftotal =0;
            this.$refs.addPurch.invtype =1;
            this.$refs.addPurch.invtype =1;
            this.$refs.addPurch.cashajl = 1;
            this.$refs.addPurch.tbrows =[];
            this.$refs.addPurch.newrow = {
                item_number: '',
                item_name: '',
                unit: this.lang.pace,
                qty: 1,
                item_price: '',
                total: '',
                vat: '',
                ftotal: ''
            };
            this.$refs.addPurch.enableAdd();
        },
        exportE(type){
            let url = '';
            if(type == 'e'){
                url = this.$store.state.SAMCOTEC.e_path;
            }else{
                url = this.$store.state.SAMCOTEC.pd_path;
            }
            const myhead = this.headers;
            const mydata = this.purchrows;
            const reportname = 'فواتير المشتريات';
            const period = this.sdate + ' - ' + this.edate;
            const head = []
            const keys = []
            
            if(myhead.length > 0){
                for(let i = 0;i < myhead.length;i++){
                    head.push(myhead[i].text);
                    if(myhead[i].text != 'الاجراء')
                        keys.push(myhead[i].value);
                }
            }
            
            const post = new FormData();
            post.append("export" , 'inrecepit');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append("keys",keys);
            post.append("header",head);
            if(mydata.length > 0){
                for(let i = 0;i< mydata.length;i++){
                    for(const [key, value] of Object.entries(mydata[i])){
                       post.append('data['+i+']['+key+']',value);
                    }
                }
            }
            post.append("reportname",reportname);
            post.append("period",period);
            axios.post( url , post)
            .then((res) => {
                window.open('../api/'+res.data.url,'_blank');
            })
        },
        printMe(item){
            const post = new FormData();
            
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('export','inrecepit');
            post.append('type',1);
            post.append('id',item.id);
        },
        ExportIt(type){
            let url = this.$store.state.SAMCOTEC.e_path+'?';
            if(type != 'e'){
                let url = this.$store.state.SAMCOTEC.pd_path+'?inrecepit';
            }
            const post = new FormData();
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('export','inrecepit');
            post.append('type',1);
            post.append('sdate','');
            post.append('edate','');
            axios.post(
                url, post
            ).then((res) => {
                var rest = res.data;
                window.open('../api' + rest.url,'_blank')
            })
        },
        ViewItem(item){
            this.$refs.viewMenow.billid = item.id;
            this.$refs.viewMenow.getBill();
            
            //this.$router.push({path: '/view-purchase/'+item.id})
        },
        getNext(page){
            this.cpage = parseInt(page) - 1;
            this.getInvoice();
        },
        getInvoice(){
            const post = new FormData();
            post.append('type','getPurchase');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',this.id);
            post.append('data[sdate]',this.sdate);
            post.append('data[edate]',this.edate);
            post.append('data[type]',1);
            post.append('data[vendor_name]',this.vendor_name);
            post.append('data[mobile]',this.mobile);
            post.append('data[invoiceno]',this.invoiceno);
            post.append('data[cpage]',this.cpage);
            post.append('data[status]',this.status);
            this.$store.state.showLoading = true
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                this.$store.state.showLoading = false
                const res = response.data;
               
                this.allres = res.results.allres
                this.pageCount = parseInt(parseInt(res.results.allres) / 15) + 1
                this.page = parseInt(this.cpage) + 1
                this.totals = res.results.totals
                this.purchrows = res.results.data;
            });
        },
        delItem(item)
        {
            const post = new FormData();
            post.append('type','delPurchase');
            post.append('defBranch',localStorage.getItem('defBranch'));
            post.append('financeYear',localStorage.getItem('financeYear'));
            post.append('auth',this.$cookies.get(this.$COOKIEPhase));
            post.append('data[id]',item.id);
            axios.post(
                this.$SAMCOTEC.r_path, post
            ).then((response) => {
                const res = response.data;
                this.getInvoice();
            });
        }
    },
    created() {
        this.getStartDate();
        this.getInvoice();
    },
    
}
</script>